const baseHost = process.env.BASE_HOST,
    dashboardHost = process.env.DASHBOARD_HOST,
    serviceDomain = process.env.SERVICE_DOMAIN,
    serviceProtocol = process.env.SERVICE_PROTOCOL || 'https',
    cookieDomain = process.env.COOKIE_DOMAIN,
    baseUrl = process.env.STATIC_BASE_URL,
    afterLogoutPath = process.env.LOGOUT_PATH,
    citiesInfoIndex = process.env.CITY_INFO_INDEX,
    juryKey = process.env.JURY_KEY || 'New Delhi',
    fromEmail = process.env.FROM_EMAIL || 'admin@flyagainonline.net',
    clientName = process.env.CLIENT_NAME || 'flyagainonline',
    whitelabelFlag = process.env.WHITELABEL_DISABLED || false,
    clientType = process.env.CLIENT_TYPE || 'b2b',
    redirectionDomains = {
        FLIGHT: `${baseHost}`,
        DASHBOARD: `${dashboardHost}`,
        HOTEL: `${baseHost}/hotel`,
        HOMEPAGE: `${baseHost}`,
        RAIL: `${baseHost}`,
        HOTEL_SERVER: `${baseHost}`
    },
    Config = {
        serverConfig: {
            mock_srv: {
                protocol: `${serviceProtocol}`,
                server: 'demo6750241.mockable.io', //Here you can edit the mock api address
                port: ''
            },
            google_srv: {
                protocol: 'https',
                server: 'maps.googleapis.com',
                port: '',
                proxyUrl: 'https://cors-anywhere.herokuapp.com/'
            },
            static_srv: {
                protocol: `${serviceProtocol}`,
                server: 'static.technogramsolutions.com',
                port: ''
            },
            xms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            rms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            fms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            hms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            ums_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: '',
            },
            gms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            pms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            oms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            }
        },
        redirectionConfig: {
            AGENT: `${redirectionDomains.FLIGHT}/flight/`,
            AGENT_STAFF: `${redirectionDomains.FLIGHT}/flight/`,
            ADMIN: `${redirectionDomains.DASHBOARD}/manage-user`,
            ACCOUNTS: `${redirectionDomains.DASHBOARD}/manage-user`,
            DISTRIBUTOR: `${redirectionDomains.DASHBOARD}/manage-user`,
            DISTRIBUTOR_STAFF: `${redirectionDomains.DASHBOARD}/manage-user`,
            CALLCENTER: `${redirectionDomains.DASHBOARD}/manage-carts`,
            SALES: `${redirectionDomains.DASHBOARD}/manage-user`,
            SUPPLIER: `${redirectionDomains.DASHBOARD}/manage-inventory`,
            SUPPLIER_ADMIN: `${redirectionDomains.DASHBOARD}/manage-inventory`,
            SUPERVISOR: `${redirectionDomains.DASHBOARD}/manage-carts`,
            WHITELABEL_PARTNER: `${redirectionDomains.DASHBOARD}/manage-user`,
            WHITELABEL_STAFF: `${redirectionDomains.DASHBOARD}/manage-user`
        },
        isRelativeUrl: false,
        redirectionDomains: {
            FLIGHT: `${baseHost}`,
            DASHBOARD: `${dashboardHost}`,
            HOTEL: `${baseHost}`,
            HOMEPAGE: `${baseHost}`,
            HOTEL_SERVER: `${baseHost}`
        },
        flightProductUrl: baseHost,
        serviceDomain,
        whitelabelFlag,
        serviceProtocol,
        baseUrl, afterLogoutPath,
        clientName,
        currEnv: 'test',
        EnableDownloadAsPDF: true,
        EnableSpecialCategory: true,
        EnableSessionTime: false,
        sessionExpireTimeLimit: 5,
        maxRetry: 30,
        pdpRetry: 10,
        backendPdpRetry: false,
        markupAllowConfig: {
            "EXPEDIA": false
        },
        panCardObj: {
            isPANVisible: true, // for pan card and passport to be visible
            supplierList: ['TJDesiya', 'TJTAMTOUR', 'TJclertrip', 'TJLOCAL', 'TJOYO', 'TJTAMARIND', 'TJExpedia', 'TJCLEARTRIP', 'TJagoda']
        },
        citiesInfoIndex,
        emailData: "admin@flyagainonline.net",
        contact: "011-43554899",
        companyName: 'flyagainonline',
        year: '2021',
        staticFooter: false,
        searchBoxHeading: "Your Hotel Search is just Click away",
        defaultLogo: '//static.technogramsolutions.com/img/logo-flyagainonline.png',
        searchbox_V2: true, // second design for searchbox
        juryKey,
        fromEmail,
        cookieDomain,
        defaultRole: 'CUSTOMER',
        clientType,
        showVoucherCode: false,
        payfeeText: 'Payment Fee',
        b2c: {
            showVoucherCode: true,
            showFlightMobile: true,
            showHotelMobile: true,
            enablePointsAndCoins: false,
            onloadPopupConfig: {
                showOnloadPopup: true,
                frequency: 86400,
                displayOnLogin: true
            },
            showAddToQuote: false,
            showPerNightPrice: false,
            editMarkup: false,
            searchByLocationFilter: false,
            holdAllowed: false,
            fetchTripAdvisor: false,
            afterLogoutPath: '/hotel',
            defaultRatings: '1,2,3,4,5',
            EnableSpecialCategory: false,

            autoFillPaxMobile: false,
            autoFillPaxEmail: false,
            payfeeText: 'Convenience Fee',
            salesConfirmationMail: {
                'TJLOCAL': []
            }
        },
        showDepositCredit: true,
        enablePointsAndCoins: false,
        onloadPopupConfig: {
            showOnloadPopup: true,
            frequency: 86400,
            displayOnLogin: true
        },
        showAddToQuote: true,
        showPerNightPrice: true,
        editMarkup: true,
        searchByLocationFilter: true,
        holdAllowed: true,
        fetchTripAdvisor: true,
        defaultRatings: '3,4,5',
        defaultRoomInfo: {
            numberOfAdults: 1,
            numberOfChild: 0,
            childAge: []
        },
        defaultDate: {
            startDate: 1,
            endDate: 2,
        },

        autoFillPaxMobile: false,
        autoFillPaxEmail: false,
        highlightBookingNotes: false,
        salesConfirmationMail: {
            'TJLOCAL': []
        },
        allConfirmationMail: [],
        cacheTimer: {
            offersNotificationCaching: 600,
            menubarCaching: 0,
            footerCaching: 0,
            leftnavCaching: 0,
        },
        dynamicBookingNotes: [],
        sendConfirmationToMappedSalesUser: false,
        travellerNameUnique: ['EXPEDIA'],
        noSpaceInFirstName: ['CLEARTRIP'],
        showRecentSearch: true,
        autoSuggestLengthLimit: 20,
        hotelExclusionList: [],
        panCardValidation: false,
        panCardMatchPercetage: 70,
        panCardValidationStatus: [200, 422],
        verificationByPassRoles: ['ADMIN'],
        mealPlanFilterPDP: {
            showFilter: false,
            removeExtraHeaders: false,
            mealBasisHeaders: ['Room Only', 'Breakfast', 'Half Board', 'Full Board'],
            mealBasisMapping: {}
        },
        showUnica: false,
        imageConfigSearchPage: ['EXPEDIA', 'HOTELBEDS'],
        loadAllPolicyPDP: false,
        cleanSearchResult: false,
        initialRoomView: false,
        groupOptionsVisible: 1,
        showSwitch: false,
        customPagination: {
            hotelImages: 12,
            roomImages: 6,
            roomImagesMobile: 3
        },
        roomAdditionalInfo: false,
        applyRoleConfig: false,
        applyGroupConfig: false,
        roleBasedConfig: {},
        groupBasedConfig: {},
        setCitySort: false,
        stickyFormLinks: {},
        splitStayCities: [],
        hotelSearchSize: 20,
        showRecentBooking: false,
        recentBookingDateRange: 7,
        trackingId: '',
        setCityEnabled: false,
        showMultiCity: false,
        unicaExclusionList: [],
        showOnRequestBookingPopup: false,
        analyticsEventEnable: false,
        emailPassport: false,
        enableCorporateBooking: false,
        enableSamePanPerBooking: false,
        showCheapestRoomOptions: false,
        showAddToFavourite: false,
        showTJVerified: false,
        showTrustYouReviews: false,
        searchByLocationDistance: {
            subRegionradius: 5,
            centerDistance: 10,
            enableSearchByLocation: false
        },
        CancellationPolicyAlert: false,
        roomMappingExclusions: [
            {
                cities: ['MALDIVES'],
                supplierIds: ['TJLOCAL']
            }
        ],
        paymentV2: [],
        dateCountryPopupData: {},
        showShareBy: false,
        searchByHotelName: [],
        incentivesBanner: {
            visible: false,
            data: [
                {
                    id: 1,
                    imgUrl: 'https://static.tripjack.com/banners/e5c51525-63ed-4606-8f40-a66e3a8cfd4b.jpg',
                    redirectUrl: 'https://tripjack.lpages.co/resorts-world-cruises/'
                },
            ]
        },
        emailIdsConfigs: {
            tcsEmailIds: ""
        },
        showRoomConsent: false
    };

module.exports = Config;
